export default __webpack_public_path__ + "static/media/photo--lg--janie2.e9def53a.jpg";